import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const paintAndCoating = {
    application: "",
    createdBy: "",
    createdDate: "",
    location: "",
    modifiedBy: "",
    modifiedDate: "",
    name: "",
    paintAndCoatingId: 0,
    pchmchm: "",
    purchaseOrderId: 0,
    quantity: "",
    remarks: "",
    shipId: 0,
    unit: "",
    isUpdated: false,
    isDeleted: false
}

class PaintCoatingSystem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addPaintAndCoating:
            {
                application: "",
                createdBy: "",
                createdDate: "",
                location: "",
                material: "",
                modifiedBy: "",
                modifiedDate: "",
                name: "",
                paintAndCoatingId: null,
                pchmchm: "",
                purchaseOrderId: null,
                quantity: "",
                remarks: "",
                shipId: null,
                unit: "",
                isUpdated: false,
                isDeleted: false
            },
            paintAndCoating: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { match, option } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        const { addPaintAndCoating } = this.state
        if (option == "Add") {
            addPaintAndCoating.shipId = parseInt(shipid);
            addPaintAndCoating.purchaseOrderId = parseInt(poid);
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            paintAndCoating: props.paintCoating,
            addPaintAndCoating: props.updateDetails,
        };
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addPaintAndCoating[nodeName] = e.target.value;
        this.state.addPaintAndCoating.isUpdated = true;
        this.setState({});
    }

    addPaintCoatingDetails() {
        this.state.addPaintAndCoating.isDeleted = false;
        this.state.paintAndCoating.unshift({...this.state.addPaintAndCoating});
        this.props.dispatch({ type: "GetPaintCoatingSuccess", data: this.state.paintAndCoating });
        // this.setState({ addPaintAndCoating :  {
        //     application: "",
        //     createdBy: "",
        //     createdDate: "",
        //     location: "",
        //     modifiedBy: "",
        //     modifiedDate: "",
        //     name: "",
        //     paintAndCoatingId: null,
        //     pchmchm: "",
        //     purchaseOrderId: null,
        //     quantity: "",
        //     remarks: "",
        //     shipId: null,
        //     unit: "",
        //     isUpdated: false,
        //     isDeleted: false
        // }}, () => {
        //     console.log("hi", this.state.addPaintAndCoating)
        //   });
        // this.hideSidePanel();
    }

    UpdatePaintCoating() {
        const { addPaintAndCoating } = this.state;
        var index = this.state.paintAndCoating.findIndex(x => x.paintAndCoatingId === addPaintAndCoating.paintAndCoatingId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                paintAndCoating: [
                    ...this.state.paintAndCoating.slice(0, index),
                    Object.assign({}, this.state.paintAndCoating[index], addPaintAndCoating),
                    ...this.state.paintAndCoating.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetPaintCoatingSuccess", data: this.state.paintAndCoating });
                this.hideSidePanel();
            });
        }
    }


    cancel() {
        this.hideSidePanel();
    }

    render() {
        const { option } = this.props;
        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                        </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {option == "Add" ? "Add " : "Update "} Paint & Coating Systems
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Application </label><br></br>
                                                <input type="text" value={this.state.addPaintAndCoating.application} name="application" onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" value={this.state.addPaintAndCoating.name} name="name" onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" value={this.state.addPaintAndCoating.location} name="location" onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" value={this.state.addPaintAndCoating.material} name="material" onChange={e => this.handleInputChange(e)} className="form-control"></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" value={this.state.addPaintAndCoating.remarks} onChange={e => this.handleInputChange(e)} name="remarks"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Materials
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.quantity} onChange={e => this.handleInputChange(e)} name="quantity"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.unit} onChange={e => this.handleInputChange(e)} name="unit"></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addPaintAndCoating.pchmchm} onChange={e => this.handleInputChange(e)} name="pchmchm"></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {this.props.option === "Add" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addPaintCoatingDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                : null}
                                            {this.props.option === "Edit" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdatePaintCoating()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                                : null}
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        paintCoating: state.MMPLDashboardReducer.PaintCoating || [],
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaintCoatingSystem));